import type { BucketModel } from '@sosocio/creator-types/database';

/**
 * Identify only the configured private upload bucket across its S3 endpoints.
 * Object paths can contain filename-derived extensions, so telemetry retains
 * the bucket root while storage continues to use the original object key.
 *
 * @param bucket Auto-expire bucket, absent before application data has loaded.
 * @returns Explicit bucket roots for the shared telemetry URL collapse policy.
 */
export function getAutoExpireTelemetryUrlPrefixes(
	bucket?: Pick<BucketModel, 'label' | 'region' | 'url'>,
): string[] {
	if (!bucket) {
		return [];
	}

	const prefixes: string[] = bucket.url ? [bucket.url] : [];

	if (bucket.label && bucket.region) {
		const domain = bucket.region.startsWith('cn-')
			? 'amazonaws.com.cn'
			: 'amazonaws.com';

		prefixes.push(
			`https://${bucket.label}.s3.${bucket.region}.${domain}`,
			`https://${bucket.label}.s3-accelerate.${domain}`,
			`https://${bucket.label}.s3.${domain}`,
			`https://s3.${bucket.region}.${domain}/${bucket.label}`,
			`https://s3.${domain}/${bucket.label}`,
		);
	}

	return [...new Set(prefixes)];
}
